import { createFileRoute } from '@tanstack/react-router'
import type { ActivityEntry } from '@workspace/seedforge-ui/activity-log'
import { ActivityLogView } from '@workspace/seedforge-ui/activity-log'
import { FounderLayout } from '../../../../components/founder-layout'

export const Route = createFileRoute('/app/startup/$id/activity')({
  component: ActivityLogPage,
})

const ENTRIES: ActivityEntry[] = [
  {
    id: '1',
    type: 'pitch_submitted',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Submitted pitch "SeedForge Pre-Seed" for AI review',
    timestamp: 'Mar 5, 2:14 PM',
  },
  {
    id: '2',
    type: 'login',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Signed in from Chrome on macOS',
    timestamp: 'Mar 5, 2:01 PM',
    metadata: 'IP 89.176.42.11 · Prague, CZ',
  },
  {
    id: '3',
    type: 'invite_accepted',
    actor: { name: 'Marek Horyna', initials: 'MH' },
    description: 'Accepted invitation and joined the workspace',
    timestamp: 'Mar 3, 10:22 AM',
  },
  {
    id: '4',
    type: 'invite_sent',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Invited marek@seedforge.com to the workspace',
    timestamp: 'Mar 3, 9:45 AM',
  },
  {
    id: '5',
    type: 'settings_changed',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Updated notification preferences',
    timestamp: 'Mar 2, 4:30 PM',
  },
  {
    id: '6',
    type: 'pitch_submitted',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Submitted pitch "SeedForge Pitch Review" for AI review',
    timestamp: 'Mar 2, 11:05 AM',
  },
  {
    id: '7',
    type: 'login',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Signed in from Safari on iOS',
    timestamp: 'Mar 1, 8:12 AM',
    metadata: 'IP 89.176.42.11 · Prague, CZ',
  },
  {
    id: '8',
    type: 'data_exported',
    actor: { name: 'David Rakusan', initials: 'DR' },
    description: 'Exported workspace data as JSON',
    timestamp: 'Feb 28, 3:20 PM',
  },
]

function ActivityLogPage() {
  return (
    <FounderLayout activeNav="">
      <ActivityLogView entries={ENTRIES} />
    </FounderLayout>
  )
}
